import React, { use } from "react";

import {
  ColorContext,
  ColorVariant,
  theme,
} from "@/components/canvas-editor/components/Container";
import { cn } from "@/lib/utils";

export function ListWrapper({
  children,
  columnCount,
  ...props
}: React.ComponentProps<"div"> & {
  children: React.ReactNode;
  columnCount?: number;
}) {
  return (
    <div
      className="grid gap-2"
      style={{
        gridTemplateColumns: columnCount
          ? `repeat(${columnCount}, minmax(200px, 1fr))`
          : "repeat(auto-fit, minmax(200px, 1fr))",
      }}
      {...props}
    >
      {children}
    </div>
  );
}

export function ReadOnlyValue({
  children,
  id,
  className,
  variant: variantProp = "default",
}: {
  children: React.ReactNode;
  id?: string;
  className?: string;
  variant?: ColorVariant;
}) {
  const variant = use(ColorContext) || variantProp;

  return (
    <div
      id={id}
      className={cn(
        theme.readOnly[variant === "slate" ? "default" : variant],
        "text-sm px-2 py-1 border rounded-md break-all min-w-0 w-fit",
        className,
      )}
    >
      {children}
    </div>
  );
}
